export const SchedulerProviderArray = (Data) => {
    return ({
        type: Data?.type,
        payload: Data?.payload,
    })
}